import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs';


@Injectable({
    providedIn: 'root',
})
export class NavigationService {

    constructor(
        private router: Router
    ) { }

    public pageTitle$ = new BehaviorSubject<string>("FPP");
    public hasBackLink$ = new BehaviorSubject<boolean>(false);
    public menuLink$ = new BehaviorSubject<any[]>([]);
    public activePage$ = new BehaviorSubject<string>("home");
    private backLink!: string[];
    private backLinkParams: any;
    private backFunction!: Function;
    public titleHeader$ = new BehaviorSubject<string>("");

    setPageTitle(newTitle: string, backUrl?: any[], backUrlParams?: any) {
        this.pageTitle$.next(newTitle);
        if (backUrl) {
            this.backLink = backUrl;
            this.hasBackLink$.next(true);
            this.backLinkParams = backUrlParams;
        } else {
            //this.backLink = null;
            this.hasBackLink$.next(false);
        }
    }

    setBackFunction(backFunction: Function){
        this.backFunction = backFunction;
    }

    setmenuLink(menuLink: any) {
        this.menuLink$.next(menuLink);
    }

    setActivePage(codePage: string) {
        this.activePage$.next(codePage);
    }

    setTitleHeader(title: string) {
        this.titleHeader$.next(title);
    }

    navigateBack() {
        if(this.backFunction){
            this.backFunction();
            //this.backFunction = null;
            return;
        }
        if (this.backLinkParams) {
            this.backLink.push(this.backLinkParams);
        }
        this.router.navigate(this.backLink);
    }

    navigateMenuLink(menuItem : any) {
        this.activePage$.next(menuItem.code);
        this.router.navigate(menuItem.link);
    }

    navigateMyProfile() {
        this.activePage$.next('my-profile');
        this.router.navigate(['admin','my-profile']);
    }

}
